/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from '../src/auth/authService'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'Poll',
          component: () => import('./views/pages/Poll/Poll.vue')
        },
        {
          path: '/question',
          name: 'Question',
          component: () => import('./views/pages/Poll/Poll.vue')
        },
        {
          path: '/spinrandom',
          name: 'SpinRandom',
          component: () => import('./views/pages/Spin/Spin.vue')
        },
        {
          path: '/poll/view/:id',
          name: 'Poll View',
          component: () => import('./views/pages/Poll/View.vue')
        },
        {
          path: '/report',
          name: 'report',
          component: () => import('./views/pages/Report/report.vue')
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login/Login.vue')
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/Register/Register.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/guest/play',
          name: 'play',
          component: () => import('./views/pages/Play/play.vue')
        },
        {
          path: '/poll/beforeplay/:id',
          name: 'BeforePlay',
          component: () => import('./views/pages/Poll/BeforePlay.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.authRequired) {
    if (!(auth.isAuthenticated())) {
      router.push({ path: '/Guest/Play', query: { to: to.path } })
    }
  }
  console.log(to.path);
  if (to.path != '/guest/play') {
    if (localStorage.getItem("userInfo")) {
      next();
    } else {
      auth.logOut();
      router.push({ path: '/guest/play' }).catch((err) => { });
    }
  } else {
    if (localStorage.getItem("userInfo")) {
      if (to.path == '/guest/play') {
        router.push({ path: '/' }).catch((err) => { });
      }
    } else {
      auth.logOut();
    }
  }
  next();
});


export default router
